import { Reducer, Dispatch }                     from 'redux'
import * as request                              from 'superagent'
import * as fetch                                from 'isomorphic-fetch'

import { Reference, ReferenceCategory, UiError } from './../domain/models'

// Ajax
export const AJAX_ERROR                           = 'AJAX_ERROR'
export const REQUEST_REFERENCES                   = 'REQUEST_REFERENCES'
export const RECEIVE_REFERENCES                   = 'RECEIVE_REFERENCES'
export const REQUEST_REFERENCE_CATEGORIES         = 'REQUEST_REFERENCE_CATEGORIES'
export const RECEIVE_REFERENCE_CATEGORIES         = 'RECEIVE_REFERENCE_CATEGORIES'
export const REQUEST_REFERENCE_YEARS              = 'REQUEST_REFERENCE_YEARS'
export const RECEIVE_REFERENCE_YEARS              = 'RECEIVE_REFERENCE_YEARS'
// References Filter                              
export const SELECT_YEAR                          = 'SELECT_YEAR'
export const DESELECT_YEAR                        = 'DESELECT_YEAR'
export const SELECT_REFERENCE_CATEGORY            = 'SELECT_REFERENCE_CATEGORY'
export const DESELECT_REFERENCE_CATEGORY          = 'DESELECT_REFERENCE_CATEGORY'
export const CLEAR_FILTER                         = 'CLEAR_FILTER'
export const SHOW_FILTER                          = 'SHOW_FILTER'
export const HIDE_FILTER                          = 'HIDE_FILTER'
// Paging                                         
export const PAGINATION_NEXT_PAGE                 = 'PAGINATION_NEXT_PAGE'
export const PAGINATION_PREVIOUS_PAGE             = 'PAGINATION_PREVIOUS_PAGE'
export const PAGINATION_TO_PAGE                   = 'PAGINATION_TO_PAGE'

// Ajax
export interface RequestReferences {
    type: 'REQUEST_REFERENCES'
    page: number
    years: number[]
    categoriesIds: number[]
}
export interface AjaxError {
    type: 'AJAX_ERROR'
    errorCode: number
    error: string
    errorMessage: string
}
export interface ReceiveReferences {
    type: 'RECEIVE_REFERENCES'
    references: Reference[]
    lastPage: number
}
export interface RequestReferenceCategories {
    type: 'REQUEST_REFERENCE_CATEGORIES'
}
export interface ReceiveReferenceCategories {
    type: 'RECEIVE_REFERENCE_CATEGORIES'
    referenceCategories: ReferenceCategory[]
}
export interface RequestReferenceYears {
    type: 'REQUEST_REFERENCE_YEARS'
}
export interface ReceiveReferenceYears {
    type: 'RECEIVE_REFERENCE_YEARS'
    years: number []
}
// References Filter
export interface SelectYear {
    type: 'SELECT_YEAR'
    year: number
}
export interface DeSelectYear {
    type: 'DESELECT_YEAR'
    year: number
}
export interface SelectReferenceCategory {
    type: 'SELECT_REFERENCE_CATEGORY'
    categoryId: number
}
export interface DeSelectReferenceCategory {
    type: 'DESELECT_REFERENCE_CATEGORY'
    categoryId: number
}
export interface ClearFilter {
    type: 'CLEAR_FILTER'
}
export interface ShowFilter {
    type: 'SHOW_FILTER'
}
export interface HideFilter {
    type: 'HIDE_FILTER'
}
// Paging
export interface PaginationNextPage {
    type: 'PAGINATION_NEXT_PAGE'
}
export interface PaginationPreviousPage {
    type: 'PAGINATION_PREVIOUS_PAGE'
}
export interface PaginationToPage {
    type: 'PAGINATION_TO_PAGE'
    page: number
}

export interface ReferencesAppState {
    isLoading: boolean
    showFilter: boolean

    error: UiError
    page: number

    references: Reference[]
    lastPage: number
    referenceCategories: ReferenceCategory[]
    years: number[]

    selectedYears: number[]
    selectedCategoriesIds: number[]
}

type KnownActions = RequestReferences
    | AjaxError
    | ReceiveReferences
    | RequestReferenceCategories
    | ReceiveReferenceCategories
    | RequestReferenceYears
    | ReceiveReferenceYears
    | SelectYear
    | DeSelectYear
    | SelectReferenceCategory
    | DeSelectReferenceCategory
    | ClearFilter
    | ShowFilter
    | HideFilter
    | PaginationNextPage
    | PaginationPreviousPage
    | PaginationToPage

export const actionCreators = {
    // Ajax ------------------------------------------------------------------------------------------------------------------------------------
    ajaxError: ( errorCode: number, error: string, errorMessage: string ) => <AjaxError>{ type: AJAX_ERROR, errorCode, error, errorMessage },
    requestReferences: ( page: number, years: number[], categoriesIds: number[] ) => <RequestReferences>{ type: REQUEST_REFERENCES, page, years, categoriesIds },
    receiveReferences: ( references: Reference[], lastPage: number ) => <ReceiveReferences>{ type: RECEIVE_REFERENCES, references, lastPage },
    requestReferenceCategories: () => <RequestReferenceCategories>{ type: REQUEST_REFERENCE_CATEGORIES },
    receiveReferenceCategories: ( referenceCategories: ReferenceCategory[] ) => <ReceiveReferenceCategories>{ type: RECEIVE_REFERENCE_CATEGORIES, referenceCategories },
    requestReferenceYears: () => <RequestReferenceYears>{ type: REQUEST_REFERENCE_YEARS },
    receiveReferenceYears: ( years: number[] ) => <ReceiveReferenceYears>{ type: RECEIVE_REFERENCE_YEARS, years },

    // References Filter ------------------------------------------------------------------------------------------------------------------------
    selectYear: ( year: number ) => <SelectYear>{ type: SELECT_YEAR, year },
    deSelectYear: ( year: number ) => <DeSelectYear>{ type: DESELECT_YEAR, year },
    selectReferenceCategory: ( categoryId: number ) => <SelectReferenceCategory>{ type: SELECT_REFERENCE_CATEGORY, categoryId },
    deSelectReferenceCategory: ( categoryId: number ) => <DeSelectReferenceCategory>{ type: DESELECT_REFERENCE_CATEGORY, categoryId },
    clearFilter: () => <ClearFilter>{ type: CLEAR_FILTER },
    showFilter: () => <ShowFilter>{ type: SHOW_FILTER },
    hideFilter: () => <HideFilter>{ type: HIDE_FILTER },

    // Paging ------------------------------------------------------------------------------------------------------------------------------------
    paginationNextPage: () => <PaginationNextPage>{ type: PAGINATION_NEXT_PAGE },
    paginationPreviousPage: () => <PaginationPreviousPage>{ type: PAGINATION_PREVIOUS_PAGE },
    paginationToPage: ( page: number ) => <PaginationToPage>{ type: PAGINATION_TO_PAGE, page },

    // Fetching backend resources
    fetchReferences: ( page: number, years: number[], categoriesIds: number[] ) => {
        return ( dispatch: Dispatch<Reference> ) => {
            dispatch( actionCreators.requestReferences( page, years, categoriesIds ) )
            return request
                .get( '/home/ApiReferencesGet' )
                .query( { page: page, years: years, categoriesIds: categoriesIds } )
                .end( ( err, res ) => {
                    if ( err || !res.ok ) {
                        dispatch( actionCreators.ajaxError( res.status, err, 'todo error detail' ) ) // TODO get error code
                    }
                    else {
                        dispatch( actionCreators.receiveReferences( res.body.ReferencesDtos, res.body.LastPage ) )
                    }
                } )
        }
    },
    fetchReferenceCategories: () => {
        return ( dispatch: Dispatch <ReferenceCategory> ) => {
            dispatch(actionCreators.requestReferenceCategories())
            return request.get('/home/ApiReferenceCategoriesGet')
                .end( ( err, res ) => {
                    if ( err || !res.ok ) {
                        dispatch( actionCreators.ajaxError( res.status, err, 'todo error detail' ) ) // TODO get error code
                    }
                    else {
                        dispatch( actionCreators.receiveReferenceCategories( res.body) )
                    }
                } )
        }
    },
    fetchReferenceYears: () => {
        return ( dispatch: Dispatch<number[]> ) => {
            dispatch( actionCreators.requestReferenceYears() )
            return request.get( '/home/ApiReferenceYearsGet' )
                .end( ( err, res ) => {
                    if ( err || !res.ok ) {
                        dispatch( actionCreators.ajaxError( res.status, err, 'todo error detail' ) ) // TODO get error code
                    }
                    else {
                        dispatch( actionCreators.receiveReferenceYears( res.body ) )
                    }
                } )
        }
    }
}

export const ReferencesReducer: Reducer<ReferencesAppState> = ( state: ReferencesAppState, action: KnownActions ) => {
    switch ( action.type ) {
        case AJAX_ERROR:
            return Object.assign( {}, state, {
                isLoading: false,
                error: { Error: action.error, Description: action.errorMessage, hint: '' }
            } )

        case REQUEST_REFERENCES:
            return Object.assign( {}, state, {
                isLoading: true,
            } )

        case RECEIVE_REFERENCES:
            return Object.assign( {}, state, {
                isLoading: false,
                error: null,
                references: action.references,
                lastPage: action.lastPage
            } )

        case REQUEST_REFERENCE_CATEGORIES:
            return Object.assign( {}, state, {
                isLoading: true,
            } )

        case RECEIVE_REFERENCE_CATEGORIES:
            return Object.assign( {}, state, {
                isLoading: false,
                error: null,
                referenceCategories: action.referenceCategories
            } )

        case REQUEST_REFERENCE_YEARS:
            return Object.assign( {}, state, {
                isLoading: true
            } )

        case RECEIVE_REFERENCE_YEARS:
            return Object.assign( {}, state, {
                isLoading: false,
                error: null,
                years: action.years
            } )

        case SELECT_YEAR:
            if ( ( state.selectedYears.indexOf( action.year ) === -1 ) ) {
                return Object.assign( {}, state, {
                    selectedYears: state.selectedYears.concat( action.year )
                } )
            } 
            else { return Object.assign( {}, state, state ) }

        case DESELECT_YEAR:
            const indexOfYear = state.selectedYears.indexOf( action.year );
            if ( indexOfYear !== -1 ) {
                return Object.assign( {}, state, {
                    selectedYears: state.selectedYears
                        .slice( 0, indexOfYear )
                        .concat( state.selectedYears.slice( indexOfYear + 1 ) ),
                } )
            } 
            else { return Object.assign( {}, state, state )}

        case SELECT_REFERENCE_CATEGORY:
            if ( ( state.selectedCategoriesIds.indexOf( action.categoryId ) === -1 ) ) {
                return Object.assign( {}, state, {
                    selectedCategoriesIds: state.selectedCategoriesIds.concat( action.categoryId )
                } )
            }
            else { return Object.assign( {}, state, state ) }

        case DESELECT_REFERENCE_CATEGORY:
            const indexOfCategory = state.selectedCategoriesIds.indexOf( action.categoryId );
            if ( indexOfCategory !== -1 ) {
                return Object.assign( {}, state, {
                    selectedCategoriesIds: state.selectedCategoriesIds
                        .slice( 0, indexOfCategory )
                        .concat( state.selectedCategoriesIds.slice( indexOfCategory + 1 ) ),
                } )
            }
            else { return Object.assign( {}, state, state ) }

        case CLEAR_FILTER:
            return Object.assign( {}, state, {
                selectedCategoriesIds: [],
                selectedYears: []
            } )

        case SHOW_FILTER:
            return Object.assign( {}, state, {
                showFilter: true
            } )

        case HIDE_FILTER:
            return Object.assign( {}, state, {
                showFilter: false
            } )

        case PAGINATION_NEXT_PAGE:
            return Object.assign( {}, state, {
                page: state.page + 1
            } )

        case PAGINATION_PREVIOUS_PAGE:
            if ( !(state.page <= 1) ) {
                return Object.assign( {}, state, {
                    page: state.page - 1
                } )
            }
            else { return Object.assign( {}, state, state ) }

        case PAGINATION_TO_PAGE:
            return Object.assign( {}, state, {
                page: action.page
            } )

        default:
            return state
    }
}


/** WEBPACK FOOTER **
 ** C:/BIZJ/Code/Business/Flexxus/Flexxus.Web/Scripts/flexxus-references-app/src/store/references.ts
 **/